import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc.js';
import duration from 'dayjs/plugin/duration.js';
import customParseFormat from 'dayjs/plugin/customParseFormat.js';
import isoWeek from 'dayjs/plugin/isoWeek';
import { DEFAULT_LOCALE } from '@/shared/constants/app';
import 'dayjs/locale/en';
import 'dayjs/locale/zh';

dayjs.extend(utc);
dayjs.extend(duration);
dayjs.extend(customParseFormat);
dayjs.extend(isoWeek);
dayjs.locale(DEFAULT_LOCALE);

export default dayjs;
